import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { Category } from "../../categories.types";
import { requestCategoryPriority } from "./categoryPriority.request";

const useCategoryPriority = (
  options?: MutationOptions<Category[], ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCategoryPriority,
    ...options
  });
};

export default useCategoryPriority;
